module.exports = __webpack_public_path__ + "90e5c22de7f20df3ea96817d49697276.svg";